<template>
  <div id="app">
    <div class="fill-space" v-if="initializationFailed">
      <p class="lead text-center center-center">No Connection to Server</p>
    </div>
    <div v-else-if="initializationComplete">
      <router-view/>
    </div>
    <div class="fill-space" v-else>
      <p class="lead text-center center-center">Connecting...</p>
    </div>
  </div>
</template>

<script>
// import AppNavbar from '@/components/Navbar.vue'

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    initializationComplete () {
      return this.$store.getters.initializationComplete
    },
    initializationFailed () {
      return this.$store.getters.initializationFailed
    },
  },
  methods: {
  },
  mounted () {
    console.log('App.mounted')
    console.log('  initializationStarted', this.$store.getters.initializationStarted)
    if (!this.$store.getters.initializationStarted) {
      this.$store.dispatch('initialize')
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #eee;
  color: #2c3e50;
  min-height: 100vh;
}
#app .fill-space {
  margin: 0;
  width: 100%;
  height: 100%;
}
#app .center-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 50%;
  transform: translateX(-50%);
}

#app .container {
  min-height: 100vh;
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

#app .clickable {
  cursor: pointer;
}

@media print {
  #app {
    background-color: transparent;
  }
  #app .container {
    width: 100%;
  }
  #app .container.shadow-sm {
    box-shadow: none !important;
  }
}
</style>
